import { axios } from "utils";

import { ADMIN_NEWS_URL as endpoint } from "consts";

export const getAllAdminNews = async (data) => axios.get(`${endpoint}`, { data });

export const addNews = async (data) => axios.post(`${endpoint}`, { data });

export const getNews = async (data) => axios.get(`${endpoint}/${data.id}`, { data });

export const updateNews = async (data) => axios.put(`${endpoint}/${data.link}`, { data });
